module.exports = __webpack_public_path__ + "resources/img/bg_solution_main3_v2.9efdee2040ea51da18131aac56cbac06.png";